import { createGlobalStyle } from 'styled-components'

import { mobile } from '@/utils/media-query'

export const LandingLayoutGlobalStyle = createGlobalStyle`
  body {
    background: black;
    color: white;
  }

  p {
    font-size: 18px;
    line-height: 24px;
    color: ${({ theme }) => theme.palette.giphyWhite};
    opacity: 0.66;

    @media ${mobile.query} {
      color: ${({ theme }) => theme.palette.giphyWhite};
      font-size: 18px;
      line-height: 26px;
      opacity: 0.8;
    }
  }
`
